/** * メッセージ詳細ダイアログ表示コンポーネント */
<template>
  <ifield-b-modal
    id="the-message-detail"
    ref="the-message-detail-modal"
    v-bind:title="$t('theMessageDetail.message')"
    v-model="isShown"
    size="lg"
    body-class="message-detail-dialog-body"
    centered
    scrollable
    static
  >
    <message-detail ref="message-detail" message-type="receive" />

    <!-- modal footer -->
    <template v-slot:modal-footer="{ cancel }">
      <!-- 閉じるボタン -->
      <b-button
        size="sm"
        variant="secondary"
        v-on:click="cancel"
        v-t="'theMessageDetail.action.close'"
      />
    </template>
  </ifield-b-modal>
</template>

<script>
import MessageDetail from '@/components/message/AppMessageDetail.vue'

export default {
  components: {
    'message-detail': MessageDetail,
  },
  filters: {},
  data: function () {
    return {
      /**
       * モーダル表示フラグ
       * @type {Boolean}
       */
      isShown: false,
    }
  },
  computed: {},
  mounted: function () {
    this.$log.info('TheMessageDetail mounted')
  },
  methods: {
    /**
     * モーダルダイアログを表示する
     * @param {Object} messageId 報告書詳細データ
     */
    showModal: function (messageId) {
      this.$refs['message-detail'].show(messageId).then(() => {
        this.isShown = true
      })
    },

    /**
     * モーダルダイアログを非表示にする
     */
    hideModal: function () {
      this.isShown = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .message-detail-dialog-body {
  background-color: #ffffff;
}
</style>
